import React, { useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  InputLabel,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  InputValidatePropType,
  InputValidatePropTypeTwo,
} from "../../interface/inputs";
import { labelSty, styInput } from "./styles-input";

// Styled components
export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", // Adjust this value as needed
    boxShadow: "0px 2px 4px 0px #465FF11A",

    "& fieldset": {
      borderColor: "#45917366",
      boxShadow: "0px 2px 4px 0px #465FF11A",
      "&:hover": {
        borderColor: "#45917366",
        boxShadow: "0px 2px 4px 0px #465FF11A",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#45917366",
        boxShadow: "0px 2px 4px 0px #465FF11A",
      },
    },
    "& input": {
      // Add your styInput styles here
      fontFamily: "Poppins",
      fontSize: "13px",
      borderRadius: "8px",
    },
  },
  "& .MuiFormHelperText-root": {
    // Style for error message
    color: theme.palette.error.main,
  },
  "& .MuiFormControl-root": {
    borderRadius: "8px",
  },
}));
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  // Add any custom styles for the IconButton here

  padding: theme.spacing(1),
}));

const EmailInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  // const classes = useStyles(); // Call the hook here

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>

      <StyledTextField
        placeholder={placeholder ?? "Enter your email address or phone number"}
        type="email"
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ""}
        {...register("email")}
      />
    </Stack>
  );
};
const NameInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  // const classes = useStyles();

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      <StyledTextField
        placeholder={placeholder ?? "Enter Name"}
        type="text"
        error={!!errors.name}
        helperText={errors.name ? errors.name.message : ""} // Render error message only when there's an error
        {...register("name")}
        slotProps={{
          input: {
            style: styInput,
          },
        }}
      ></StyledTextField>
    </Stack>
  );
};
const PasswordInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>

      <StyledTextField
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : ""}
        {...register("password")}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <StyledIconButton onClick={handleTogglePassword} edge="end">
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </StyledIconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};

const ConfirmInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>

      <StyledTextField
        error={!!errors.confirmPassword}
        helperText={errors.confirmPassword ? errors.confirmPassword.message : ""}
        {...register("confirmPassword")}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <StyledIconButton onClick={handleTogglePassword} edge="end">
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </StyledIconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};

const CustomPasswordInput = ({
  errors,
  register,
  placeholder,
  labelText,
  name,
}: InputValidatePropTypeTwo) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>

      <StyledTextField
        error={!!errors}
        helperText={errors ? errors : ""}
        {...register(name)}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <StyledIconButton onClick={handleTogglePassword} edge="end">
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </StyledIconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};
const ConfirmPasswordInput = ({
  errors,
  register,
  placeholder,
  labelText,
}: InputValidatePropType) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      <TextField
        error={!!errors.passwordConfirm}
        helperText={
          errors.passwordConfirm ? errors.passwordConfirm.message : ""
        } // Render error message only when there's an error
        {...register("passwordConfirm")}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePassword}>
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
          inputProps: {
            style: styInput,
          },
        }}
      />
    </Stack>
  );
};

export { PasswordInput, ConfirmPasswordInput, EmailInput, NameInput, CustomPasswordInput, ConfirmInput };
